module.exports = __webpack_public_path__ + "img/PRINT.51f03d35.svg";